import { ServerNoDistApi, ServerDistApi } from '@/group-cloud/network/ServerBizApi';
export class TransferApi {
  protected static groupUrl = '/wms';
  //调拨出列表查询
  public static getTransferFromList(data) {
    let uri = this.groupUrl + '/transfer/pageFrom';
    return ServerNoDistApi.send(uri, data);
  }
  //调拨入列表查询
  public static getTransferToList(data) {
    let uri = this.groupUrl + '/transfer/pageTo';
    return ServerNoDistApi.send(uri, data);
  }
  //取消调拨
  public static deleteTransferData(data) {
    let uri = this.groupUrl + '/transfer/cancel';
    return ServerNoDistApi.get(uri, data);
  }
  //确认调出
  public static confirmOutData(data) {
    let uri = this.groupUrl + '/transfer/confirm';
    return ServerNoDistApi.get(uri, data);
  }
  //确认调入
  public static confirmInData(data) {
    let uri = this.groupUrl + '/transfer/finish';
    return ServerNoDistApi.get(uri, data);
  }
  //保存调拨草稿
  public static saveTransfer(data) {
    let uri = this.groupUrl + '/transfer/cacheSave';
    return ServerNoDistApi.send(uri, data);
  }
  //编辑查看获取详情
  public static getTransferInfo(data) {
    let uri = this.groupUrl + '/transfer/detail';
    return ServerNoDistApi.get(uri, data);
  }
  //删除调拨库单
  public static deleteTransfer(data) {
    let uri = this.groupUrl + '/transfer/delete';
    return ServerNoDistApi.get(uri, data);
  }
  //选择主体列表
  public static getMainList(data) {
    let uri = this.groupUrl + '/ws/bodyList';
      return ServerDistApi.get(uri, data);
  }
  //获取仓库列表
  public static getStoreList(data) {
    let uri = this.groupUrl + '/ws/bodyToWs';
      return ServerDistApi.send(uri, data);
  }

    //调拨出
    public static downloadForm(data) {
      let uri = this.groupUrl + '/transfer/pageFromExport';
        return ServerNoDistApi.send(uri, data);
    }

    //调拨入
    public static downloadTo(data) {
      let uri = this.groupUrl + '/transfer/pageToExport';
        return ServerNoDistApi.send(uri, data);
    }
}